<div class="bg_calculator">
  <app-headercontent></app-headercontent>
  <div class="container mb-3" *ngIf="budget != null">
    <a class="back__link" [routerLink]="['/budget-preview/'+budget.IdBudget]">Operaciones de Mantenimiento</a>
  </div>
  <div class="bg_selected_car pt-3 pb-7">
    <div *ngIf="showForm && loaded" class="cont__form">
      <div class="container">

        <div class="row mb-2">
          <div class="col-md-12">
            <strong>Tu CUPRA:</strong>
          </div>
        </div>
        <form [formGroup]="dataform" (ngSubmit)="saveCupraCare()">
          <div *ngIf="budget" class="row">
            <div class="col-md-6">
              <img [src]="pathServer + budget.ModelVersion.ModelImage" alt="Tu CUPRA" class="img-fluid">
            </div>
            <div class="col-md-6 my__cupra">
              <div class="model">{{budget.ModelVersion.Model}}</div>
              <div class="motor">{{budget.ModelVersion.MotorType}}</div>
              <div class="version">{{budget.ModelVersion.Version}}</div>
              <div class="version">{{budget.Distributor}}</div>
            </div>
          </div>
          <div class="row mt-3 mb-2">
            <div class="col-12">
              <hr />
              <h3>Pedir cita</h3>
            </div>
          </div>

          <div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" id="Ccname" formControlName="CcName" class="form-control floatLabel" [ngClass]="{ 'is-invalid': submitted && f.CcName.errors,'is-valid': !f.CcName.errors  }" class="form-control" placeholder="Nombre" />
                  <label for="CcName">Nombre</label>
                  <div *ngIf="submitted && f.CcName.errors" class="invalid-feedback">
                    <div *ngIf="f.CcName.errors.required">Nombre requerido</div>
                    <div *ngIf="f.CcName.errors.maxlength">Nombre demasiado largo</div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" id="CcSurname" formControlName="CcSurname" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.CcSurname.errors,'is-valid': !f.CcSurname.errors  }" class="form-control" placeholder="Apellidos" />
                  <label for="CcSurnamee">Apellidos</label>
                  <div *ngIf="submitted && f.CcSurname.errors" class="invalid-feedback">
                    <div *ngIf="f.CcSurname.errors.required">Apellidos requeridos</div>
                    <div *ngIf="f.CcSurname.errors.maxlength">Apellidos demasiados largos</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" id="mail" formControlName="CcEmail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.CcEmail.errors, 'is-valid': !f.CcEmail.errors }" placeholder="Correo electrónico" />
                  <label for="CcEmail">Email</label>
                  <div *ngIf="submitted && f.CcEmail.errors" class="invalid-feedback">
                    <div *ngIf="f.CcEmail.errors.required">Correo electrónico requerido</div>
                    <div *ngIf="f.CcEmail.errors.pattern">Formato Incorrecto</div>
                    <div *ngIf="f.CcEmail.errors.maxlength">Correo electrónico demasiado largo</div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="number" id="phone" formControlName="CcPhone" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.CcPhone.errors, 'is-valid': !f.CcPhone.errors }" placeholder="Teléfono" />
                  <label for="CcPhone">Teléfono</label>
                  <div *ngIf="submitted && f.CcPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.CcPhone.errors.required">Teléfono requerido</div>
                    <div *ngIf="f.CcPhone.errors.pattern">Formato Incorrecto</div>
                    <div *ngIf="f.CcPhone.errors.max">Formato Incorrecto</div>
                    <div *ngIf="f.CcPhone.errors.min">Formato Incorrecto</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" id="Matricula" formControlName="Matricula" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Matricula.errors, 'is-valid': submitted && !f.Matricula.errors }" class="form-control
                           " placeholder="Matrícula" />
                  <label for="Matricula">Matrícula</label>
                  <div *ngIf="submitted && f.Matricula.errors" class="invalid-feedback">
                    <div *ngIf="f.Matricula.errors.required">Matrícula requerida</div>
                    <div *ngIf="f.Matricula.errors.maxlength">Matrícula demasiado larga</div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" id="Bastidor" formControlName="Bastidor" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.Bastidor.errors, 'is-valid': submitted && !f.Bastidor.errors }" class="form-control
                           " placeholder="Bastidor" />
                  <label for="Bastidor">Bastidor</label>
                  <div *ngIf="submitted && f.Bastidor.errors" class="invalid-feedback">
                    <div *ngIf="f.Bastidor.errors.required">Bastidor requerido</div>
                    <div *ngIf="f.Bastidor.errors.maxlength">Bastidor demasiado largo</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div (click)="selectDistri(elem.IdDistributor)" *ngFor="let elem of distrisList" class="card mt-2" style="width: 18rem;cursor: pointer;" id="distri{{elem.IdDistributor}}">

                            <div class="card-body">
                                <h5 class="card-title">{{elem.Distributor}}</h5>
                            </div>
                            <div class="card-text">
                                {{elem.Address}} {{elem.Cp}} {{elem.City}}
                            </div>
                        </div> -->
            <div class="row select__distributor" *ngIf="budget.IdDistributor == null">
              <div class="col-md-12 my-2">
                <h5>Selecciona el Servicio Especialista CUPRA:</h5>
                <div *ngIf="submitted && f.CcIdDistributor.errors">
                  <div *ngIf="f.CcIdDistributor.errors.required" class="d-flex flex-row-reverse">
                    <div class="form-control w-25 is-invalid border-0"></div>
                    <div class="invalid-feedback flex-shrink-1">Instalación requerida</div>
                  </div>
                </div>
              </div>
              <div class="btn-distributor col-md-6 mb-3" (click)="selectDistri(elem.IdDistributor)" *ngFor="let elem of distrisList" id="distri{{elem.IdDistributor}}">
                <div class="card">
                  <div class="card-header">
                    {{elem.Distributor}}
                  </div>
                  <div class="card-body">
                    <ul>
                      <li>{{elem.Address}}</li>
                      <li>{{elem.Cp}} <span class="sep">|</span> {{elem.City}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="row my-1">
            <div class="col-md-12">
              <div class="legal-button-box mb-3">
                <p><strong>Responsable:</strong> CUPRA (SEAT, S.A.U)</p>
                <p><strong>Finalidades:</strong> Gestionar tu solicitud y/o petición de contacto.</p>
                <p><strong>Legitimación:</strong> El interés legítimo en tramitar y atender tu solicitud.</p>
                <p><strong>Destinatarios:</strong> Comunicaremos tus datos al concesionario oficial seleccionado (o que selecciones en un futuro) para tramitar tu petición y/o la solicitud de contacto.
                  Adicionalmente, te informamos que utilizamos proveedores de servicios de alojamiento de datos y publicidad programada que pueden estar ubicados fuera del EEE. Si deseas más información, ponte en contacto con el DPO o consulta nuestra <a href="https://www.cupraofficial.es/politica-privacidad.html" title="Política de Privacidad" target="_blank">Política de Privacidad</a>.</p>
                <p><strong>Derechos:</strong> Puedes ejercer tus derechos de protección de datos, en el siguiente email: <a href="mailto:privacy@cupraofficial.es">privacy@cupraofficial.es</a>.<br>
                  Dispones de la información detallada de protección de datos en el siguiente enlace <a href="https://www.cupraofficial.es/politica-privacidad.html" title="Política de Privacidad" target="_blank">Política de Privacidad</a>.</p>
              </div>
              <p class="legal">Enviando el formulario declaro haber leído y aceptado la <a href="https://www.cupraofficial.es/politica-privacidad.html" title="Política de Privacidad" target="_blank">Política de Privacidad</a>.</p>
            </div>
          </div>

          <div class="row mt-3 mt-md-4">
            <div class="col-md-12 text-center"><button type="submit" class="btn btn-primary">Solicitar cita previa</button></div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="!showForm && loaded">
      <div class="container">
        <div class="row mt-3 mt-md-5 mb-3">
          <div class="col-md-12">El Servicio Especialista CUPRA contactará contigo a la mayor brevedad posible para agendar la cita.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>